/**
 * AS SUGESTÕES DE FÁBRICA — o chão que aparece quando esta casa ainda não
 * escreveu as suas.
 *
 * ── POR QUE ISTO SAIU DE DENTRO DO COMPONENTE (24/09/2026) ────────────────
 *
 * Porque duas telas precisam da mesma lista e por razões opostas: o `Ben`
 * DESENHA-A quando o catálogo do workspace não cobre a tela, e a tela de
 * sugestões precisa de a MOSTRAR — era o defeito que o dono apontou: "elas se
 * repetem em todas as telas do sistema, mas o usuário não altera elas em lugar
 * nenhum". Uma constante privada dentro do `ChatSuggestions.vue` fazia da
 * pergunta "o que o Ben oferece hoje?" uma coisa que só se responde lendo
 * código.
 *
 * ── CHAVES E NÃO FRASES ───────────────────────────────────────────────────
 *
 * O que viaja aqui é o caminho do dicionário, nunca o texto: a mesma lista tem
 * de sair em sete línguas, e uma frase escrita aqui seria a oitava cópia da
 * primeira que alguém traduzisse. Quem as desenha chama `t(key)`.
 *
 * ── A ORDEM É A OFERTA ────────────────────────────────────────────────────
 *
 * A primeira é a que a maioria toca (ver `no-more-hats` e a decisão de 24/09
 * sobre "Crie o site"), então a ordem não é alfabética nem histórica: é o que
 * uma casa recém-aberta quer primeiro.
 */

/**
 * O chão, por PORTA — e não por chapéu.
 *
 * ── UM BEN SÓ (15/09/2026) ────────────────────────────────────────────────
 *
 * Os chapéus acabaram: não há "Ben do site", "Ben construtor" nem "Ben
 * operador" — há UM Ben por workspace, e o `mode` da sessão (builder/operator)
 * é uma propriedade da SUPERFÍCIE, que decide que ferramentas existem. Por isso
 * a chave aqui é `internal`, o painel, e não um dos modos: a pergunta "o que
 * posso pedir?" é a mesma nos dois.
 *
 * `attendant` é outra coisa e continua a ser: o agente que fala com o CLIENTE.
 * Esse não é o Ben.
 */
export const DEFAULT_OPENERS: Record<string, readonly string[]> = {
	/** O painel — o Ben, em qualquer modo de sessão. */
	internal: [
		// O site primeiro: é o que quem acaba de abrir a conta quer do Ben.
		"suggestions.panel.site",
		// As respostas rápidas do "/" — a tela com papel `composer.snippet`, que o
		// Ben sabe escrever a partir da receita (`domain/recipes/`).
		// E etiquetar, um gesto nativo: o Ben do painel etiqueta, e o atendente
		// etiqueta a pessoa da conversa dele (05/10).
		"suggestions.panel.snippets",
		"suggestions.panel.tagging",
		"suggestions.panel.screen",
		"suggestions.panel.stalled",
	],
	/** A conversa com o cliente: o atendente, que não é o Ben. */
	interaction: ["suggestions.attendant.discount"],
};

/**
 * O chão de uma thread DENTRO DE UMA CONVERSA.
 *
 * Por PORTA e não por modo: o mesmo Ben é outro ajudante aqui — "o que mudou
 * hoje?" é a pergunta certa no painel e a errada com um cliente esperando do
 * outro lado da tela.
 */
// Neutras de propósito: um exemplo de negócio ("a garantia") é errado para quase todo workspace.
export const DEFAULT_IN_CONVERSATION: readonly string[] = [
	"suggestions.inConversation.reply",
	"suggestions.inConversation.summarise",
	"suggestions.inConversation.known",
];
